import { PERSONAL_WORKSPACE_ID } from '@store/reducers/dashboard/constants'
import type React from 'react'
import { Navigate } from 'react-router-dom'

import { DASHBOARD_LINK } from '../constants'

// /templates раньше открывал модалку галереи, снесённую в OCT-5044. Ссылка
// живёт на маркетинговом сайте (кнопка Template gallery) и в письмах, поэтому
// остаётся редиректом на раздел Templates личного воркспейса.
export const Templates: React.FC = () => (
  <Navigate
    to={`${DASHBOARD_LINK}/${PERSONAL_WORKSPACE_ID}/templates`}
    replace
  />
)
